export class FileMetadata {
  duration: number;
  width: number;
  height: number;
  size: number;
}
